import EZAxios from '@/ezaxios';
import store from '@/store';

export default {
  calculateTaxes(address,order_type){
    let data = {
      address: address.address,
      address2: address.address2,
      zip: address.postal_code,
      city: address.city,
      state: address.state,
      country: address.country,
      order_type: order_type
    };

    let activeUser = store.state.activeUser;
    if (!activeUser)
      data.device_id = store.state.device_id;
    else
      data.customer_slug = activeUser.data.customer.slug;

    data.country = data.country == "USA" ? "US" : data.country;
    return EZAxios.post(`calculate-taxes`, data);
  },
  assignAddress(address, type) {
    let data = {
      address: address.address,
      address2: address.address2,
      zip: address.postal_code,
      city: address.city,
      state: address.state,
      country: address.country,
      order_type: type
    };

    let activeUser = store.state.activeUser;
    if (!activeUser)
      data.device_id = store.state.device_id;
    else
      data.customer_slug = activeUser.data.customer.slug;

    data.country = data.country == "USA" ? "US" : data.country;
    return EZAxios.post(`assign-address`, data);
  },
  addItem(item, id, qty, special = -1) {
    let activeUser = store.state.activeUser;
    let data = {
      store_product_id: id,
      quantity: qty,
      special: special
    };
    if (!activeUser) {
      data.device_id = store.state.device_id;
    } else {
      data.customer_slug = activeUser.data.customer.slug;
    }

    return EZAxios.post(`add-to-cart`, data);
  },
  removeItem(id, special = -1) {
    let activeUser = store.state.activeUser;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;
    q += '&special_order=' + special;
    return EZAxios.delete(`remove-cart-item?store_product_id=${id}&${q}`);
  },
  cartDetails() {
    let activeUser = store.state.activeUser;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;
    return EZAxios.get(`cart-parcels?${q}`);
  },
  emptyCart() {
    let activeUser = store.state.activeUser;
    let order_id = store.state.cart.order_id;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;
    if (order_id) {
      q += `&order_id=${order_id}`;
    }
    return EZAxios.get(`empty-cart?${q}`);
  },
  saveCart() {
    let cart = store.state.cart;
    let activeUser = store.state.activeUser;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;

    return EZAxios.post(`save-cart?${q}`, cart);
  },
  updateCart(id) {
    let data = {};
    data.id = id;
    let activeUser = store.state.activeUser;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;
    return EZAxios.post(`update-current-cart?${q}`, data);
  },
  checkActiveCoupons() {
    return EZAxios.get(`check-active-coupons`);
  },
  doTvrSignup(data) {
    return EZAxios.post(`truevalue/rewards-signup`, data);
  },
  doTvrLookup(data) {
    return EZAxios.post(`truevalue/rewards-lookup`, data);
  },
  shippingQuotes(data) {
    let activeUser = store.state.activeUser;
    let q = activeUser ? `customer_slug=${activeUser.data.customer.slug}` : `device_id=${store.state.device_id}`;
    return EZAxios.post(`shipping-quotes?${q}`, data);
  },
  getFiservHash(data) {
    let activeUser = store.state.activeUser;
    if (!activeUser)
      data.device_id = store.state.device_id;
    else
      data.customer_slug = activeUser.data.customer.slug;

    return EZAxios.post(`get-fiserv-hash`, data);
  },
};
